var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('router-link',{attrs:{"to":"/"}},[_c('v-btn',{staticClass:"custom-first-rtbutton",attrs:{"fab":"","fixed":"","right":"","top":"","color":"#ffc72c"}},[_c('v-icon',[_vm._v("mdi-home")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }